import { ModalComponent } from "..";
import { Notifications } from "../../navs/notifications";

export const AppNotificationsModal = ({
  isModalOpen,
  onModalClose,
}: {
  isModalOpen: boolean;
  onModalClose: () => void;
}) => {
  return (
    <ModalComponent
      isModalOpen={isModalOpen}
      onModalClose={() => {
        onModalClose();
      }}
      title={undefined}
      subTitle={undefined}
      childrenClassName="!mt-0"
      modalClassName="!py-0 !px-0"
      hasButtons={false}
      modalStyle="side"
      showHeader={false}
    >
      <Notifications
        close={() => {
          onModalClose();
        }}
        showCloseButton
      />
    </ModalComponent>
  );
};
